var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.0001 27H78.0001V72H84.0001V27Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0001 57H36.0001V39H54.0001V45H42.0001V51H54.0001V57Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0001 48H81.0001V42H96.0001C97.6551 42 99.0001 40.655 99.0001 39C99.0001 37.345 97.6551 36 96.0001 36H81.0001V30H96.0001C100.963 30 105 34.0375 105 39C105 43.9625 100.963 48 96.0001 48Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0001 69H81.0001V63H96.0001C97.6551 63 99.0001 61.655 99.0001 60C99.0001 58.345 97.6551 57 96.0001 57H81.0001V51H96.0001C100.963 51 105 55.0375 105 60C105 64.9625 100.963 69 96.0001 69Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0001 72H72.0001C59.5926 72 49.5001 61.9075 49.5001 49.5C49.5001 37.0925 59.5926 27 72.0001 27H75.0001V72ZM69.0001 33.2725C61.3301 34.6875 55.5001 41.425 55.5001 49.5C55.5001 57.575 61.3276 64.3125 69.0001 65.7275V33.2725Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2101 96H22.6001V90H35.2101C38.8226 90 41.9301 87.3075 41.9976 84.12C42.0751 80.4475 39.3326 78.67 36.7401 78.2325C35.8551 78.0825 34.9551 78.0125 34.0001 77.935C32.2151 77.795 30.3701 77.6475 28.3801 76.985C25.7976 76.125 23.6451 74.7975 21.9876 73.04C19.1526 70.0325 17.7776 65.7825 18.0151 60.7475C18.4301 51.9175 26.1601 45 35.6126 45H38.9976V51H35.6126C29.3701 51 24.2726 55.405 24.0076 61.03C23.8976 63.38 24.2151 66.6575 26.3526 68.925C27.3226 69.9525 28.6426 70.75 30.2751 71.295C31.5701 71.7275 32.9151 71.8325 34.4701 71.955C35.5151 72.0375 36.5926 72.1225 37.7401 72.3175C44.0026 73.3775 48.1226 78.1725 47.9926 84.25C47.8551 90.73 42.1176 96 35.2051 96H35.2101Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/Electricity.7e083150.svg";
export { ForwardRef as ReactComponent };